export default import.meta.ROLLDOWN_FILE_URL_4LYNCHXyA4UFB0rokgmWHw